import { createI18n } from 'vue-i18n';

import sl from './locales/sl';

export enum Locales {
  HR = 'hr',
  SL = 'sl'
}

export const LOCALES = [
  { value: Locales.HR, caption: 'Hrvaščina' },
  { value: Locales.SL, caption: 'Slovenščina' }
];

export const translations = {
  [Locales.SL]: sl
};

const usersLanguage = window.navigator.language.split('-')[0];
const availableLocales = Object.keys(translations);
const defaultLocale = availableLocales.includes(usersLanguage as Locales)
  ? (usersLanguage as Locales)
  : Locales.SL;

const i18n = createI18n({
  legacy: false, // for composition API
  messages: translations,
  locale: defaultLocale,
  fallbackLocale: Locales.SL
});

export default i18n;
